import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import services from '../../services';
import { type ServicesState } from './servicesTypes';
import { sortServicesByPrice } from '../../services/appointment/utils';
import { type CustomerType } from '../user/userTypes';

const initialState: ServicesState = {
  availableServices: [],
  isLoading: false,
  showRetry: false,
};

export const getServices = createAsyncThunk(
  'services/getServices',
  async (
    {
      customerType,
      allowedMemberDiscounts,
      zipCode,
      operation,
      stateCode,
    }: {
      customerType: CustomerType;
      allowedMemberDiscounts: boolean;
      zipCode: string;
      operation: string;
      stateCode: string | undefined;
    },
    { rejectWithValue },
  ) => {
    const { result, error } = await services.appointment.getAvailableServices(
      customerType,
      allowedMemberDiscounts,
      zipCode,
      operation,
      stateCode,
    );

    if (error) {
      return rejectWithValue(error);
    }

    if (operation.startsWith('design') && CSS_CONFIG.services.sortByPrice) {
      result.services.sort(sortServicesByPrice);
    }
    return result.services;
  },
);

const servicesSlice = createSlice({
  name: 'services',
  initialState,
  reducers: {
    clearAvailableServices(state) {
      state.availableServices = [];
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getServices.fulfilled, (state, action) => {
      state.availableServices = action.payload;
      state.isLoading = false;
      state.showRetry = false;
    });
    builder.addCase(getServices.pending, (state) => {
      state.availableServices = [];
      state.isLoading = true;
      state.showRetry = false;
    });
    builder.addCase(getServices.rejected, (state) => {
      state.availableServices = [];
      state.isLoading = false;
      state.showRetry = true;
    });
  },
});

export const { clearAvailableServices } = servicesSlice.actions;

export default servicesSlice.reducer;
